import { request } from '@/utils/ajax';

export interface SearchDependenciesOptions {
    projectId: number;
}

export function addDependency(options: AddDependency): Promise<DependencyGroupDto> {
    return request(`api/dependency`, {
        method: 'PUT',
        body: options,
        json: true,
    }).then((x) => x.json());
}

export function searchDependencies(options: SearchDependenciesOptions): Promise<DependencyGroupDto[]> {
    return request(`api/dependency`, {
        query: options,
    }).then((x) => x.json());
}
export function getDependency(groupId: number): Promise<DependencyGroupDto> {
    return request(`api/dependency/${groupId}`).then((x) => x.json());
}

export function deleteDependency(groupId: number): Promise<any> {
    return request(`api/dependency/${groupId}`, {
        method: 'DELETE',
    });
}

export interface DependencyGroupDto {
    id: number;
    name: string;
    projectId: number;
    fromOptionGroupId: number;
    toOptionGroupId: number;
    dependencyItems: DependencyItemDto[];
}

export interface DependencyItemDto {
    from: number;
    to: number;
}

export interface AddDependency {
    id?: number | null;
    name: string;
    projectId: number;
    fromOptionGroupId: number;
    toOptionGroupId: number;
    dependencyItems: DependencyItemDto[];
}

/**
 * Stable codes the backend returns in the body of a 409 from `PUT api/dependency`,
 * so the UI can show a specific reason instead of one generic "already exists" message.
 * Keep in sync with `DependencyConflictCode` in bygr-backend.
 */
export const DependencyConflictCode = {
    AlreadyExists: 'DEPENDENCY_ALREADY_EXISTS',
    DeadlineMismatch: 'DEPENDENCY_DEADLINE_MISMATCH',
    LinkTypeMismatch: 'DEPENDENCY_LINK_TYPE_MISMATCH',
    Circular: 'DEPENDENCY_CIRCULAR',
} as const;